import moment from "moment";

export const gmtDate = (value: any) => {
  const day = moment(value).format("dddd");
  const date = moment(value).format("MMM Do YYYY");
  const time = moment(value).format("LTS");
  const offset = moment(value).format("Z");
  const gmt = `${day}, ${date}, ${time} (GMT${offset})`;
  return gmt;
};

/**
 * Overridden moment's fromNow, with floor rounding for more precision
 * 8.2 days => 8 days; 8.9 days => 8 days
 * @param {Date|Number (timestamp)|date-string(Date.parse)|Moment} timestamp
 * @returns {string} Relative human readable time string
 */
export const fromNowWithFloorRounding = (timestamp: any) => {
  const time = moment(timestamp);
  const roundingDefault = moment.relativeTimeRounding();

  // Round relative time evaluation down
  moment.relativeTimeRounding(Math.floor);

  // Updating thresholds
  moment.relativeTimeThreshold("s", 60);
  moment.relativeTimeThreshold("m", 60);
  moment.relativeTimeThreshold("h", 24);
  moment.relativeTimeThreshold("d", 31);
  moment.relativeTimeThreshold("M", 12);

  const relatimeTime = time.fromNow();

  // back to default
  moment.relativeTimeRounding(roundingDefault);
  return relatimeTime;
};

export const ABSOLUTE_DATE_TIME_FORMAT = "MMMM D YYYY, hh:mm a";

export const formatPastTime = (timestamp: string | number | Date) => {
  const now = new Date();
  const date = new Date(timestamp);
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  // Just now (less than 1 minute ago)
  if (diffInSeconds < 60) {
    return "Just now";
  }

  // Minutes ago (less than 1 hour)
  if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;
  }

  // Hours ago (less than 24 hours)
  if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
  }

  // Today at HH:MM
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  if (date >= today) {
    return `Today at ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
  }

  // Yesterday at HH:MM
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (date >= yesterday) {
    return `Yesterday at ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
  }

  // Default to date and time for older messages
  return (
    date.toLocaleDateString([], {
      month: "short",
      day: "numeric"
    }) +
    " at " +
    date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    })
  );
};
